import React from 'react';

import { IBasicStyledProps, Row, SkeletonElement } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';

import {
  FlexStartCol,
  StyledDescriptionSkeleton,
  StyledProductCol,
  StyledRemoveButtonColumn,
  StyledSmallBar,
  StyledTitleSkeleton,
} from './styled';

export const ProductSkeleton: ReactFCV<IBasicStyledProps> = (rest) => (
  <Row {...rest}>
    <FlexStartCol data-testid="start-col" xs={4} md={1}>
      <SkeletonElement data-testid="skeleton-element" width={5} height={5} />
    </FlexStartCol>
    <StyledProductCol data-testid="product-col" xs={8} md={7}>
      <StyledTitleSkeleton data-testid="skeleton-title" />
      <StyledDescriptionSkeleton data-testid="skeleton-description" />
    </StyledProductCol>
    <FlexStartCol data-testid="start-col" xs={6} md={2}>
      <StyledSmallBar data-testid="small-bar" />
    </FlexStartCol>
    <StyledRemoveButtonColumn data-testid="remove-btn-col" xs={6} md={2}>
      <StyledSmallBar data-testid="small-bar" />
    </StyledRemoveButtonColumn>
  </Row>
);
